import { isRejectedWithValue } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const status = action.payload?.status;
    const originalStatus = action.payload?.originalStatus;

    // Ignore PARSING_ERROR on 2xx responses: the request actually succeeded,
    // the body just wasn't JSON (e.g. APIs answering with plain-text
    // 'success'). Showing a "Request Failed" toast for these is misleading.
    if (status === "PARSING_ERROR" && originalStatus >= 200 && originalStatus < 300) {
      console.warn(
        "Non-JSON 2xx response treated as success:",
        action.payload?.data
      );
      return next(action);
    }

    // Ignore 401 Unauthorized errors since they are handled by baseQueryWithReauth
    if (status !== 401) {
      const message =
        action.payload?.data?.message ||
        action.payload?.data ||
        action.payload?.message ||
        "An unexpected network error occurred.";

      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: typeof message === "string" ? message : JSON.stringify(message),
        toast: true,
        position: "top-end",
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
      });
    }
  }

  return next(action);
};
